export function PageSeparator() {
  return (
    <div className="w-full py-2 flex items-center justify-center">
      <div className="w-full h-1 relative">
        {/* Main gradient line */}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-cyan/40 to-transparent" />
        {/* Glow effect */}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-cyan/20 to-transparent blur-sm" />
      </div>
    </div>
  );
}
